import { eventActions } from '../../../../store/modules/event';
import { useDispatch } from 'react-redux';
import { EventOption } from '../../../../store/modules/event/type';

const useEventInProgressListViewModel = (inProgressEvent: any) => {
  const dispatch = useDispatch();

  /**
   * 진행중인 기획전 리스트 조회하기 (검색, 페이지네이션시 사용)
   */
  const getInProgressEventList = (data: Partial<EventOption>) => {
    const { filterOption, pagination } = inProgressEvent.inProgressEventList;
    dispatch(
      eventActions.getInProgressEventList({
        filterOption,
        pagination,
        ...data,
      }),
    );
  };

  const getEventTagColumnTagList = (data: any) => {
    dispatch(eventActions.getEventTagColumnTagList(data));
  };

  return {
    getInProgressEventList,
    getEventTagColumnTagList,
  };
};

export default useEventInProgressListViewModel;
